import React, { useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import enUS from "date-fns/locale/en-US";
const DateRangeSelector = ({ setDate, isPast, minDate }) => {
  const [selectedRange, setSelectedRange] = useState({
    startDate: null,
    endDate: null,
    key: "rollup",
  });

  const HandleSelect = (ranges) => {
    if (ranges.selection) {
      const { startDate, endDate } = ranges.selection;
      const adjustedEndDate = new Date(endDate);
      adjustedEndDate.setHours(23, 59, 59, 999);
      setSelectedRange({
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
      });
      setDate({
        startDate,
        endDate: adjustedEndDate
      });
    }
  };

  return (
    <div>
      <DateRangePicker
        startDatePlaceholder="Start Date"
        endDatePlaceholder="End Date"
        ranges={[
          {
            startDate: selectedRange.startDate,
            endDate: selectedRange.endDate,
            key: "selection",
          },
        ]}
        onChange={HandleSelect}
        inputRanges={[]}
        locale={enUS}
        editableDateInputs={true}
        showMonthAndYearPickers={false}
        showSelectionPreview={true}
        showMonthArrow={true}
        minDate={isPast ? undefined : minDate ? minDate : new Date()}
        color="#333333"
        rangeColors={["#333333"]}
      />
    </div>
  );

};

export default DateRangeSelector;